import { NgZone } from '@angular/core';
import { setupConfig } from '@bkkr/core';
import { applyPolyfills, defineCustomElements } from '@bkkr/core/dist/loader';

import { Config } from './providers/config';
import { BkkrWindow } from './types/interfaces';
import { raf } from './util/util';

export const appInit = (config: Config, doc: Document, zone: NgZone) => {
  return (): any => {
    const win: BkkrWindow | undefined = doc.defaultView as any;
    if (win && typeof (window as any) !== 'undefined') {
      setupConfig({
        ...config,
        _zoneGate: (h: any) => zone.run(h),
      });

      const aelFn =
        '__zone_symbol__addEventListener' in (doc.body as any) ? '__zone_symbol__addEventListener' : 'addEventListener';

      return applyPolyfills().then(() => {
        return defineCustomElements(win, {
          exclude: ['bkkr-tabs', 'bkkr-tab'],
          syncQueue: true,
          raf,
          jmp: (h: any) => zone.runOutsideAngular(h),
          ael(elm: any, eventName: any, cb: any, opts: any) {
            (elm as any)[aelFn](eventName, cb, opts);
          },
          rel(
            elm: {
              removeEventListener: (arg0: any, arg1: any, arg2: any) => void;
            },
            eventName: any,
            cb: any,
            opts: any
          ) {
            elm.removeEventListener(eventName, cb, opts);
          },
        });
      });
    }
  };
};
